import { render, staticRenderFns } from "./CardOrderDeliveryStatusFilter.vue?vue&type=template&id=039c5bb1&"
import script from "./CardOrderDeliveryStatusFilter.vue?vue&type=script&lang=js&"
export * from "./CardOrderDeliveryStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports